<template>
  <div class="transication-container">
    <div class="table">
      <div class="table-header flex pb-10 text-gray-light">
        <div class="table-c0" :virtual-ref="buttonRef"></div>
        <div class="table-c0-1">
          <el-popover trigger="click" :visible="popoverVisible === 'platform'" :width="200">
            <template #reference>
              <span
                class="cursor-pointer text-blue"
                @click="
                  () => {
                    popoverVisible === 'platform' ? (popoverVisible = '') : (popoverVisible = 'platform')
                  }
                "
              >
                {{ $t('平台') }} <i class="iconfont icon-sanjiaoxing"></i>
              </span>
            </template>
            <div>
              <div>
                <div>
                  <el-checkbox-group v-model="selectedPlatform" :min="1">
                    <el-checkbox :value="'steam'" :label="'Steam'" :indeterminate="false">Steam</el-checkbox>
                    <br />
                    <el-checkbox :value="'third'" :label="$t('三方平台')" :indeterminate="false">{{ $t('三方平台') }}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <el-divider direction="horizontal" content-position="left" style="margin-top: 5px; margin-bottom: 5px"></el-divider>
                <div class="flex justify-between">
                  <el-button ref="buttonRef" type="primary" size="default" @click="filterConfirm('paintSeed')">{{ $t('筛选') }}</el-button>
                  <el-button type="info" size="default" @click="selectedPlatform = ['steam', 'third']">{{ $t('重置') }}</el-button>
                </div>
              </div>
            </div>
          </el-popover>
        </div>
        <div class="table-c1">
          <el-popover trigger="click" :visible="popoverVisible === 'paintSeed'" :width="200">
            <template #reference>
              <span
                class="cursor-pointer"
                :class="listQuery.paintSeed && listQuery.paintSeed.length > 0 ? 'text-blue' : ''"
                @click="
                  () => {
                    popoverVisible === 'paintSeed' ? (popoverVisible = '') : (popoverVisible = 'paintSeed')
                  }
                "
              >
                {{ $t('图案模板') }} <i class="iconfont icon-sanjiaoxing"></i>
              </span>
            </template>
            <div>
              <div>
                <el-input v-model="tempTemplateId" :placeholder="$t('图案模板')" size="normal" clearable @keyup.enter="addTemplate('paintSeed')"></el-input>
                <div>
                  <el-checkbox-group v-model="selectedPaintseeds">
                    <el-checkbox v-for="(template, index) in paintSeedList" :key="index" style="width: 180px" :label="template.label" :value="template.value" />
                  </el-checkbox-group>
                </div>
                <el-divider direction="horizontal" content-position="left" style="margin-top: 5px; margin-bottom: 5px"></el-divider>
                <div class="flex justify-between">
                  <el-button type="primary" size="default" @click="filterConfirm('paintSeed')">{{ $t('筛选') }}</el-button>
                  <el-button type="info" size="default" @click="selectedPaintseeds = []">{{ $t('重置') }}</el-button>
                </div>
              </div>
            </div>
          </el-popover>
        </div>
        <div class="table-c2">
          <el-popover trigger="click" :visible="popoverVisible === 'paintIndex'" :width="200">
            <template #reference>
              <span
                class="cursor-pointer"
                :class="listQuery.paintIndex && listQuery.paintIndex.length > 0 ? 'text-blue' : ''"
                @click="
                  () => {
                    popoverVisible === 'paintIndex' ? (popoverVisible = '') : (popoverVisible = 'paintIndex')
                  }
                "
              >
                {{ $t('皮肤编号') }}
                <i class="iconfont icon-sanjiaoxing"></i>
              </span>
            </template>
            <div>
              <div>
                <el-input v-model="tempPaintIndex" :placeholder="$t('皮肤编号')" size="normal" clearable @keyup.enter="addTemplate"></el-input>
                <div>
                  <el-checkbox-group v-model="selectedPaintIndex">
                    <el-checkbox v-for="(template, index) in paintIndexList" :key="index" style="width: 180px" :label="template.label" :value="template.value" />
                  </el-checkbox-group>
                </div>
                <el-divider direction="horizontal" content-position="left" style="margin-top: 5px; margin-bottom: 5px"></el-divider>
                <div class="flex justify-between">
                  <el-button type="primary" size="default" @click="filterConfirm('paintIndex')">{{ $t('筛选') }}</el-button>
                  <el-button type="info" size="default" @click="selectedPaintIndex = []">{{ $t('重置') }}</el-button>
                </div>
              </div>
            </div>
          </el-popover>
        </div>
        <div class="table-c3">
          <div class="flex cursor-pointer" @click="changeSort({ sortBy: 'wear' })">
            {{ $t('磨损') }}
            <sortarrow :sort-type="listQuery.sortBy === 'wear' ? listQuery.sortType.toUpperCase() : ''"></sortarrow>
          </div>
        </div>
        <div class="table-c4">
          <div class="flex items-center pt-3 text-gray-light">
            <el-dropdown>
              <span class="el-dropdown-link" :class="listQuery.hasSticker ? 'text-blue' : ''">
                {{ $t('印花') }}
                <i class="iconfont icon-sanjiaoxing"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    @click="
                      () => {
                        listQuery.hasSticker = 1
                        transicationRes.list = []
                        listQuery.nextId = ''
                        popoverVisible = ''
                        getList(true)
                      }
                    "
                    >{{ $t('有印花') }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click="
                      () => {
                        listQuery.hasSticker = 0
                        transicationRes.list = []
                        listQuery.nextId = ''
                        getList(true)
                      }
                    "
                    >{{ $t('无印花') }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click="
                      () => {
                        listQuery.hasSticker = null
                        transicationRes.list = []
                        listQuery.nextId = ''
                        getList(true)
                      }
                    "
                    >{{ $t('无限制') }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
        <div class="table-c5">
          <div class="flex cursor-pointer" @click="changeSort({ sortBy: 'tradePrice' })">
            {{ $t('成交价格') }}
            <sortarrow :sort-type="listQuery.sortBy === 'tradePrice' ? listQuery.sortType.toUpperCase() : ''"> </sortarrow>
          </div>
        </div>
        <div class="table-c6">
          {{ $t('成交时在售底价') }}
        </div>
        <div class="table-c7">
          <div class="flex cursor-pointer" @click="changeSort({ sortBy: 'tradeTime' })">
            {{ $t('成交时间') }}
            <sortarrow :sort-type="listQuery.sortBy === 'tradeTime' ? listQuery.sortType.toUpperCase() : ''"> </sortarrow>
          </div>
        </div>
      </div>
      <div
        v-if="transicationRes?.list?.length"
        v-infinite-scroll="getList"
        class="table-content"
        style="min-height: 300px"
        :infinite-scroll-delay="500"
        :infinite-scroll-disabled="loading"
        infinite-scroll-distance="200"
      >
        <div v-for="(item, index) in transicationRes.list" :key="index" class="table-item flex h-64 items-center border-b border-[#EFF1F5]">
          <div class="table-c0">
            <rankLabel :rank="index + 1"></rankLabel>
          </div>
          <div class="table-c0-1">
            <span>{{ item.platform == 1 ? 'Steam' : $t('三方平台') }}</span>
          </div>
          <div class="table-c1">
            <div style="padding-right: 30px; display: flex; flex-direction: row; justify-content: space-between">
              <span>
                {{ item.paintSeed }}
              </span>
              <span v-if="templateSeedList?.includes(item.specialStyle?.value)" :class="`custom-tag ${getTagNameAndStyle(item.specialStyle?.value)?.className}`">{{
                item.specialStyle?.name
              }}</span>
            </div>
          </div>
          <div class="table-c2">
            <div style="padding-right: 45px; display: flex; flex-direction: row; justify-content: space-between">
              <span>
                {{ item.paintIndex }}
              </span>
              <span v-if="templateIndexList?.includes(item.specialStyle?.value)" :class="`custom-tag ${getTagNameAndStyle(item.specialStyle?.value)?.className}`">{{
                item.specialStyle?.name
              }}</span>
            </div>
          </div>
          <div class="table-c3">
            <div v-if="item.wearFlot" class="w-215">
              <div class="text-gray">{{ $t('磨损') }}: {{ item.wearFlot }}</div>
              <wearbar :wear="item.wearFlot * 1"></wearbar>
            </div>
            <div v-else>{{ $t('暂无磨损') }}</div>
          </div>
          <div class="table-c4">
            <div class="flex items-center">
              <div v-for="(sticker, index) in item.stickers" :key="index" class="sticker-item flex w-45 flex-col items-center">
                <div class="mb-3 mr-5 h-27 w-35">
                  <img :src="sticker.stickerimg" alt="" />
                </div>
                <div class="text-10">{{ wearValue(sticker.wear) }}%</div>
              </div>
            </div>
          </div>
          <div class="table-c5 text-black">{{ moneyUnit }}{{ currencyTransform(item.tradePrice) }}</div>
          <div class="table-c6 text-black">{{ moneyUnit }}{{ currencyTransform(item.minSellPrice) }}</div>
          <div class="table-c7 text-black">{{ dayjs(item.tradeTime * 1000).format('YYYY-MM-DD HH:mm:ss') }}</div>
        </div>
      </div>
      <div v-else>
        <empty></empty>
      </div>
    </div>
  </div>
</template>

<script setup>
import rankLabel from '~/components/common/rankLabel.vue'
import sortarrow from '~/components/common/sortarrow.vue'
import empty from '~/components/common/empty.vue'
import wearbar from '~/components/common/wearbar.vue'
import { getDealInfo, getDealList } from '~~/api/steam'
import dayjs from 'dayjs'

const { t } = useI18n()
const $t = t

const moneyUnit = ref(monetaryUnit())
const tempTemplateId = ref('')
const tempPaintIndex = ref('')
const visiblePaintSeed = ref(false)
const visiblePaintIndex = ref(false)

const emit = defineEmits(['changesort', 'changeFilter', 'changePlatform'])

const props = defineProps({
  info: {
    type: Array,
    default: () => []
  },
  transicationQuery: {
    type: Object,
    default: () => {}
  },
  specialStyles: {
    type: Array,
    default: () => []
  },
  endTimeQuery: {
    type: String,
    default: ''
  },
  startTimeQuery: {
    type: String,
    default: ''
  },
  marketHashName: {
    type: String,
    default: ''
  }
})

const paintSeedList = ref(props?.transicationQuery?.paintSeed ? [{ label: props?.transicationQuery?.paintSeed[0], value: props?.transicationQuery?.paintSeed[0] }] : [])
const paintIndexList = ref(props?.transicationQuery?.paintIndex ? [{ label: props?.transicationQuery?.paintIndex[0], value: props?.transicationQuery?.paintIndex[0] }] : [])
const selectedPaintIndex = ref(props?.transicationQuery?.paintIndex ?? [])
const selectedPaintseeds = ref(props?.transicationQuery?.paintSeed ?? [])
const selectedPlatform = ref(['steam', 'third'])
const templateIndexList = ref([])
const templateIndexNameList = ref([])
const templateSeedList = ref([])
const templateSeedNameList = ref([])
const popoverVisible = ref('')

const transicationRes = ref({
  list: []
})

const loading = ref(false)

const listQuery = ref(JSON.parse(JSON.stringify(props.transicationQuery)))

const outClick = e => {
  if (e.target.innerText.trim() === $t('图案模板')) {
    visiblePaintSeed.value = visiblePaintSeed.value ? false : true
    return
  }
  if (visiblePaintSeed.value) visiblePaintSeed.value = false
}

const outClick1 = e => {
  if (e.target.innerText.trim() === $t('皮肤编号')) {
    visiblePaintIndex.value = visiblePaintIndex.value ? false : true
    return
  }
  if (visiblePaintIndex.value) visiblePaintIndex.value = false
}

const wearValue = wear => {
  if (wear > 1) {
    return Number(100 - wear).toFixed(2)
  }
  if (Number(wear) <= 0) {
    return 100
  }
  return Number(100 - wear * 100).toFixed(2)
}

onMounted(() => {
  if (props.specialStyles.length > 0) {
    filteStyles()
  }
 
  getList(true)
})

const getTagName = specialStyle => {
  const tag = props?.specialStyles?.find(style => style.value === specialStyle)
  if (tag) {
    return tag?.name.toUpperCase()
  }
}

const getTagNameAndStyle = specialStyle => {
  const tagName = getTagName(specialStyle)
  let classNameTag = ''

  if (specialStyle?.includes('t')) {
    classNameTag = 'tag-t'
  }
  if (specialStyle?.includes('r')) {
    classNameTag = 'tag-r'
  }
  if (props.marketHashName?.includes('Gamma Doppler')) {
    // 伽玛多普勒
    switch (specialStyle) {
      case 'p1':
        classNameTag = 'tag-p1'
        break
      case 'p2':
        classNameTag = 'tag-p2'
        break
      case 'p3':
        classNameTag = 'tag-p3'
        break
      case 'p4':
        classNameTag = 'tag-p4'
        break
      case 'emerald':
        classNameTag = 'tag-green'
        break
      default:
        ''
        classNameTag = ''
        break
    }
  } else {
    if (props.marketHashName?.includes('Doppler')) {
      // 多普勒
      switch (specialStyle) {
        case 'p1':
          classNameTag = 'tag-doppler-p1'
          break
        case 'p2':
          classNameTag = 'tag-doppler-p2'
          break
        case 'p3':
          classNameTag = 'tag-doppler-p3'
          break
        case 'p4':
          classNameTag = 'tag-doppler-p4'
          break
        case 'ruby':
          classNameTag = 'tag-doppler-red'
          break
        case 'sapphire':
          classNameTag = 'tag-doppler-blue'
          break
        case 'blackpearl':
          classNameTag = 'tag-doppler-black'
          break
        default:
          classNameTag = ''
          break
      }
    }
  }
  return {
    name: tagName,
    className: classNameTag
  }
}

const addTemplate = type => {
  if (type === 'paintSeed') {
    if (tempTemplateId.value !== '') {
      paintSeedList.value.unshift({ label: tempTemplateId.value, value: tempTemplateId.value })
      selectedPaintseeds.value.unshift(tempTemplateId.value)
      tempTemplateId.value = ''
    }
  } else {
    if (tempPaintIndex.value !== '') {
      paintIndexList.value.unshift({ label: tempPaintIndex.value, value: tempPaintIndex.value })
      selectedPaintIndex.value.unshift(tempPaintIndex.value)
      tempPaintIndex.value = ''
    }
  }

  listQuery.value.nextId = ''
}
const filterConfirm = type => {
  addTemplate(type)
  if (type === 'paintSeed') {
    visiblePaintSeed.value = false
  }
  if (type === 'paintIndex') {
    visiblePaintIndex.value = false
  }
  popoverVisible.value = ''
  listQuery.value.nextId = ''

  listQuery.value.paintSeed = selectedPaintseeds.value
  listQuery.value.paintIndex = selectedPaintIndex.value
  if (selectedPlatform.value.length > 1) {
    listQuery.value.hasSteam = -1
  } else if (selectedPlatform.value.indexOf('steam') > -1) {
    listQuery.value.hasSteam = 1
  } else {
    listQuery.value.hasSteam = 0
  }
  emit('changePlatform', listQuery.value.hasSteam)
  transicationRes.value.list = []

  getList(true)
}
const getList = isRequest => {

  loading.value = true

  if (listQuery.value.nextId === null && !isRequest) {
    return
  }
  const params = { ...listQuery.value }
  if (props?.endTimeQuery) {
    params.endTime = props.endTimeQuery
  }
  if (props?.startTimeQuery) {
    params.startTime = props.startTimeQuery
  }

  params.style = []
 
  if (params.paintSeed && params.paintSeed.length > 0) {
    params.style?.push(...params.paintSeed?.filter(ps => templateSeedList.value?.includes(ps)))
    params.paintSeed = params.paintSeed?.filter(ps => !templateSeedList.value?.includes(ps))?.filter(Boolean)
  }
  if (params.paintIndex && params.paintIndex.length > 0) {
    params.style?.push(...params.paintIndex?.filter(pi => templateIndexList.value?.includes(pi)))
    params.paintIndex = params.paintIndex?.filter(pi => !templateIndexList.value?.includes(pi))
  }
  getDealList(params).then(res => {
    transicationRes.value.list = transicationRes.value.list.concat(res.data.list)
    listQuery.value.nextId = res.data.nextId
    loading.value = false
  })
}

const changeSort = sort => {
  popoverVisible.value = ''
  if (listQuery.value.sortBy === sort.sortBy) {
    listQuery.value.sortType = listQuery.value.sortType === 'asc' ? 'desc' : 'asc'
  } else {
    listQuery.value.sortType = 'desc'
    listQuery.value.sortBy = sort.sortBy
  }
  transicationRes.value.list = []
  listQuery.value.nextId = ''

  getList(true)
  
}

const filteStyles = () => {

  // 分出图案模板和皮肤编号
  const templateIndexListArr = ['p1', 'p2', 'p3', 'p4', 'emerald', 'ruby', 'sapphire', 'blackpearl']
  for (const item of props.specialStyles) {
    if (templateIndexListArr.indexOf(item.value) > -1) {
      paintIndexList.value.push({ label: item?.name, value: item.value })
      templateIndexList.value.push(item.value)
      templateIndexNameList.value.push(item?.name)
    } else {
      paintSeedList.value.push({ label: item?.name, value: item.value })
      templateSeedList.value.push(item.value)
      templateSeedNameList.value.push(item?.name)
    }
  }

  if (props.transicationQuery?.specialStyles?.length > 0) {
    for (const special of props.transicationQuery.specialStyles) {
      if (templateIndexListArr.indexOf(special) > -1) {
        selectedPaintIndex.value.push(special)
      } else {
        selectedPaintseeds.value.push(special)
      }
    }
    listQuery.value.paintSeed = selectedPaintseeds.value
    listQuery.value.paintIndex = selectedPaintIndex.value
  }
}

const reset = () => {
  transicationRes.value.list = []
  listQuery.value.nextId = ''

  getList(true)
}

defineExpose({
  reset
})
</script>

<style lang="scss">
.transication-container {
  .table-content {
    max-height: 400px;
    overflow-y: auto;
  }
}

.table {
  .table-c0 {
    width: 40px;
  }
  .table-c0-1 {
    width: 100px;
  }

  .table-c1 {
    width: 118px;
  }

  .table-c2 {
    width: 118px;
  }

  .table-c3 {
    width: 230px;
  }

  .table-c4 {
    width: 230px;
  }

  .table-c5 {
    width: 110px;
  }

  .table-c6 {
    width: 132px;
  }

  .table-c7 {
    width: 180px;
  }
}
</style>
<style lang="scss" scoped>
.custom-tag {
  display: inline-block;
  height: 18px;
  color: #fff;
  text-align: center;
  border-radius: 9px;
  width: 34px;
  margin-right: 5px;
}

.tag-t {
  background: #0252d9;
}
.tag-r {
  background: #993a38;
}
.tag-green {
  // 绿宝石
  background: #5fb85f;
  width: 58px;
}
.tag-p1 {
  background: linear-gradient(319deg, #6078b5 0%, #8579ad 25%, #44c699 59%, #5798b9 100%);
}
.tag-p2 {
  background: linear-gradient(128deg, #5f8470 0%, #38c484 34%, #4a907b 100%);
}
.tag-p3 {
  background: linear-gradient(130deg, #59bba0 0%, #47cf81 38%, #5794a5 73%, #4f8e6b 100%);
}
.tag-p4 {
  background: linear-gradient(130deg, #69a695 0%, #44c0b4 36%, #5f877e 75%, #6fa656 100%);
}
.tag-green {
  background: #5fb85f;
}
.tag-doppler-p1 {
  background: linear-gradient(139deg, #6e4782 0%, #93476c 25%, #484c7f 59%, #82447a 100%);
}
.tag-doppler-p2 {
  background: linear-gradient(139deg, #873064 0%, #9b4470 26%, #a4375a 60%, #82447a 100%);
}
.tag-doppler-p3 {
  background: linear-gradient(141deg, #272f57 0%, #2a3472 26%, #3f2f91 60%, #262940 100%);
}
.tag-doppler-p4 {
  background: linear-gradient(141deg, #2f3c87 0%, #313e90 26%, #3f2f91 60%, #262940 100%);
}
.tag-doppler-black {
  width: 58px;
  background: #000000;
}
.tag-doppler-red {
  background: #993a38;
  width: 58px;
}
.tag-doppler-blue {
  width: 58px;
  background: #6f9ffc;
}

.text-blue {
  color: #0252d9;
}
</style>
